import { EVENTS } from "../../constants";

/**
 * takes care of observing elements and listening for events that should change body attributes
 */
class Body {
  /**
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.element = element;
    this.config = {
      fixedClass: "is-fixed",
      overlayClass: "has-overlay",
    };

    this.observe();
  }

  /**
   * adds event listeners for the events
   */
  observe() {
    this.element.addEventListener(EVENTS.MODAL_OPEN, (event) => {
      this._toggleClass(this.config.fixedClass, event.detail.isOpen);
    });

    this.element.addEventListener(EVENTS.MENU_OPEN, () => {
      this.element.classList.add(this.config.fixedClass);
    });

    this.element.addEventListener(EVENTS.MENU_CLOSE, () => {
      this.element.classList.remove(this.config.fixedClass);
    });

    this.element.addEventListener(EVENTS.OVERLAY_INIT, () => {
      this.element.classList.add(this.config.overlayClass);
    });
  }

  /**
   * toggles given class on the body
   *
   * @private
   * @param {string} cssClass
   * @param {boolean} isOpen
   */
  _toggleClass(cssClass, isOpen) {
    this.element.classList.toggle(cssClass, isOpen);
  }
}

export default Body;
